import React from 'react';
import {Alert, Button, useTitle} from "fearless-common-ui";
import {useSearchParams} from "react-router-dom";
import {Pages} from "../../components/layout";
import Description from "../../components/Description";
import {routes} from "../../utils";
import useAuth from "../../components/hooks/useAuth";

/**
 * Error page shown when the user follows a broken or expired link.
 *
 * Reads an optional `?message=` query parameter:
 *   - When present and non-empty, it is shown in a danger Alert (used by
 *     callers that want to surface a server-provided reason).
 *   - Otherwise, a generic "invalid or may have expired" description is shown.
 *
 * The "Go to home" button routes authenticated users to the post-login
 * landing page and anonymous visitors to the public homepage.
 */
export default function InvalidLink() {
  useTitle('Invalid link');
  const { user } = useAuth();
  const [sp] = useSearchParams();

  const message = sp?.get('message');

  return (
    <Pages.Centred padded width="xs">
      <h1 className="gradient-color">Invalid link</h1>
      {message
        ? <Alert variant="danger">{message}</Alert>
        : <Description>The link you followed is invalid or may have expired.</Description>}

      <Button
        icon="fa fa-arrow-left"
        href={user ? routes.landing : routes.home}
        variant="link"
      >
        Go to home
      </Button>
    </Pages.Centred>
  )
}
